import { laptopMax, largeTabletMax, mobileXLargeMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import { Container as Button } from '@propertypal/web-ui/src/buttons/Button.style';
import PageWrapper from '@propertypal/web-ui/src/layout/PageWrapper';
import { Content } from '@propertypal/web-ui/src/layout/PageWrapper.style';
import { SubHeading, Text } from '@propertypal/web-ui/src/typography';
import styled, { css } from 'styled-components';

const GAP = 10;
const DESKTOP_COLS = 4;
const LAPTOP_COLS = 3;
const TABLET_COLS = 2;

export const Container = styled.section`
  position: relative;
  padding: 45px 0 170px 0;
`;

export const Wrapper = styled(PageWrapper)`
  position: relative;
  ${Content} {
    max-width: 1150px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  ${Button} {
    background-color: ${({ theme }) => theme.darkGrey};

    &:hover {
      background-color: ${({ theme }) => theme.backgroundMid};
    }
  }
`;

export const TextContent = styled.section`
  ${SubHeading} {
    margin: 0 auto 20px;
    line-height: 1.15;

    @media (${laptopMax}) {
      font-size: 32px;
    }

    @media (${mobileXLargeMax}) {
      font-size: 30px;
    }
  }

  ${Text} {
    line-height: 1.5;
    color: #333;
    max-width: 830px;
    margin: 0 auto 70px;

    @media (${mobileXLargeMax}) {
      font-size: 18px;
    }
  }
`;

export const IconsGridItem = styled.li<{ maxW?: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  text-align: center;
  gap: 10px;

  svg {
    max-height: 80px;
    height: 100%;
  }

  ${Text} {
    color: #333;
    font-size: 24px;
    font-weight: bold;
    line-height: 1.1em;

    ${({ maxW }) =>
      maxW
        ? css`
            margin: 0 auto;
            max-width: ${maxW}px;
          `
        : ''}
  }
`;

export const IconsGrid = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  justify-content: center;
  gap: 90px ${GAP}px;
  width: 100%;
  padding: 0;
  margin: 0 0 80px;

  ${IconsGridItem} {
    flex-basis: calc((100% - (${DESKTOP_COLS} - 1) * ${GAP}px) / ${DESKTOP_COLS});

    @media (${largeTabletMax}) {
      flex-basis: calc((100% - (${LAPTOP_COLS} - 1) * ${GAP}px) / ${LAPTOP_COLS});
    }

    @media (${tabletMax}) {
      flex-basis: calc((100% - (${TABLET_COLS} - 1) * ${GAP}px) / ${TABLET_COLS});
    }

    @media (${mobileXLargeMax}) {
      flex-basis: 100%;
    }
  }

  @media (${mobileXLargeMax}) {
    gap: 60px;
  }
`;
